import { gql } from '@apollo/client';

export const SAVE_DOCUMENT_TYPE_WITH_STATE_TRANSITIONS = gql`
  mutation removeOrUpdateDocumentTypeWithStateTransitions(
    $documentTypeId: Int
    $allowedStateTransitions: [AllowedTransitionPermissionInput]
    $deletedStateTransitions: [Int]
  ) {
    removeOrUpdateDocumentTypeWithStateTransitions(
      documentTypeId: $documentTypeId
      allowedStateTransitions: $allowedStateTransitions
      deletedStateTransitions: $deletedStateTransitions
    ) {
      commandId
      correlationId
    }
  }
`;

export const EXPORT_DOCUMENT_STATE_TRANSITION_RIGHTS_LIST = gql`
  mutation exportDocumentStateTransitionRights($documentTypeId: Int!, $fileType: String) {
    exportDocumentStateTransitionRights(documentTypeId: $documentTypeId, fileType: $fileType) {
      fileId
      fileName
      filePath
      fileBytes
    }
  }
`;

export const IMPORT_DOCUMENT_STATE_TRANSITION_RIGHTS = gql`
  mutation importDocumentStateTransitionRights($documentTypeId: Int!, $file: Upload!) {
    importDocumentStateTransitionRights(documentTypeId: $documentTypeId, file: $file) {
      commandId
    }
  }
`;
